/* eslint-disable no-useless-escape */
import React from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";

export const getStringQuestionType = (questionType) => {
  /**
   * returns string/descriptive name of question type from number`
   * @param {number} questionType
   */
  const hashmap = {
    1: "MCQ",
    2: "MSQ",
    3: "NAT",
  };
  return questionType in hashmap ? hashmap[questionType] : "";
};

// Add this helper function
const injectLatexForRendering = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const mathSpans = doc.querySelectorAll("span.math-equation[data-latex]");

  mathSpans.forEach((span) => {
    const latex = span.getAttribute("data-latex");
    if (latex) {
      span.innerHTML = `\\(${latex}\\)`;
    }
  });

  return doc.body.innerHTML;
};

export const renderQuestions = (questions) => {
  return questions.map((item) => {
    const data = String(item.description);
    const removeData = data.replace(/\\n/g, " ");
    const withLatexInjected = injectLatexForRendering(removeData); // ADDED

    return (
      <>
        {item.descType === "text" ? (
          <MathJaxContext>
            <MathJax>
              <div dangerouslySetInnerHTML={{ __html: withLatexInjected }} />
            </MathJax>
          </MathJaxContext>
        ) : (
          <img
            src={item.description}
            style={{ maxWidth: "100%", maxHeight: 100 }}
            alt="images"
          />
        )}
      </>
    );
  });
};

export const renderCorrectAns = (answers) => {
  let newArr = answers?.filter((item) => item?.isCorrect);
  return newArr.map((item) => {
    const data = String(item.description);
    const removeData = data.replace(/\\n/g, " ");
    // const modifiedHtml = removeData.replace(/\\t/g, " ");
    return (
      <>
        {item.descType === "text" ? (
          <MathJaxContext>
            <MathJax>
              <div dangerouslySetInnerHTML={{ __html: removeData }} />
            </MathJax>
          </MathJaxContext>
        ) : (
          <img
            src={item.description}
            style={{ maxWidth: "100%", maxHeight: 100 }}
            alt="images"
          />
        )}
      </>
    );
  });
};

export const madeCorrectURL = (imageUrl) => {
  let key = imageUrl;
  key = key.replace(/\%28/g, "(");
  key = key.replace(/\%29/g, ")");
  key = key.replace(/\%21/g, "!");
  key = key.replace(/\%7E/g, "~");
  key = key.replace(/\%20/g, "+");
  key = key.replace(/\%26/g, "AND");
  return key;
};

export const timeConvert = (n) => {
  if (n) {
    const totalSeconds = n * 60;
    const hours = Math.floor(totalSeconds / 3600);
    const remainingSecondsAfterHours = totalSeconds % 3600;
    const mins = Math.floor(remainingSecondsAfterHours / 60);
    const seconds = remainingSecondsAfterHours % 60;
    // Format with leading zeros
    const formattedTime = [
      hours.toString().padStart(2, "0"),
      mins.toString().padStart(2, "0"),
      Math.round(seconds)?.toFixed(0).toString().padStart(2, "0"),
    ].join(":");

    return formattedTime;
  } else return "";
};

export const getWordCountFromEditor = (htmlString) => {
  if (!htmlString) return 0;
  // 1. Remove HTML tags
  let text = htmlString
    .replace(/<\/?[^>]+(>|$)/g, "") // remove HTML tags (if any)
    .replace(/\u00a0|&nbsp;/g, " ") // handle NBSP
    .replace(/\s+/g, " ");
  // .trim();
  // 3. Count words
  return text ? text?.length : 0;
};

export const createJsonFile = (data) => {
  const jsonString = JSON.stringify(data, null, 2);
  return new Blob([jsonString], { type: "application/json" });
};
